/* ============================================
   PUZZVO - Custom JavaScript
   Scroll animations & premium interactions
   ============================================ */

(function() {
  'use strict';

  // Scroll Animation Observer
  function initScrollAnimations() {
    const sections = document.querySelectorAll('.shopify-section');
    
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry, index) => {
        if (entry.isIntersecting) {
          setTimeout(() => {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
          }, index * 100);
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.05,
      rootMargin: '0px 0px -50px 0px'
    });

    sections.forEach(section => {
      section.style.opacity = '0';
      section.style.transform = 'translateY(20px)';
      section.style.transition = 'opacity 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
      observer.observe(section);
    });

    // Don't animate header and first visible section
    const header = document.querySelector('.shopify-section-group-header-group');
    if (header) {
      header.style.opacity = '1';
      header.style.transform = 'none';
    }
    const firstSection = document.querySelector('main .shopify-section:first-child');
    if (firstSection) {
      firstSection.style.opacity = '1';
      firstSection.style.transform = 'none';
    }
  }

  // Lazy image reveal
  function initLazyImages() {
    const images = document.querySelectorAll('img[loading="lazy"]');
    images.forEach(img => {
      if (img.complete) {
        img.classList.add('loaded');
      } else {
        img.addEventListener('load', () => img.classList.add('loaded'));
      }
    });
  }

  // Smooth scroll for anchor links
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function(e) {
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // Init all
  function init() {
    initScrollAnimations();
    initLazyImages();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();